import React from 'react'
import styled, { keyframes } from 'styled-components'
import PrixIcon from '~/public/prix-icon.svg'

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`

const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 35px;
  width: 100%;
  max-width: 800px;
`

const BubbleContainer = styled.div<{ $isUser: boolean }>`
  display: flex;
  justify-content: ${({ $isUser }) => ($isUser ? 'flex-end' : 'flex-start')};
  position: relative;
`

const AvatarContainer = styled.div`
  flex-shrink: 0;
  margin-right: 0.5rem;
  margin-top: 0.25rem;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  /* background: ${({ theme }) => theme.colors.primary}; */
  /* border: 2px solid #fff; */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 7px 10px 10px;
  position: relative;
  overflow: visible;
  z-index: 1;

  & > * {
    width: 100%;
    height: 100%;
  }

  @media screen and (min-width: 1081px) {
    position: absolute;
    left: -3.5rem;
    top: 0;
  }
`

const BubbleContent = styled.div<{ $isUser: boolean }>`
  position: relative;
  margin-left: 0;
  margin-right: 0;
  display: flex;
  flex-direction: column;
  align-items: ${({ $isUser }) => ($isUser ? 'flex-end' : 'flex-start')};
  flex: 1;
  max-width: 100%;
  overflow-x: hidden;
`

const BubbleBody = styled.div<{ $isUser: boolean; $width?: string }>`
  padding: 0.9rem 1rem;
  border-radius: 0.5rem;
  background-color: ${({ $isUser, theme }) => ($isUser ? theme.colors.primary : '#fff')};
  border-bottom-right-radius: ${({ $isUser }) => ($isUser ? '0' : '0.5rem')};
  border-bottom-left-radius: ${({ $isUser }) => ($isUser ? '0.5rem' : '0')};
  min-width: ${({ $width }) => $width || '200px'};
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.4) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    background-size: 1000px 100%;
    animation: ${shimmer} 2s infinite linear;
  }
`

const SkeletonLine = styled.div<{ $width?: string; $isUser?: boolean }>`
  height: 12px;
  width: ${({ $width }) => $width || '100%'};
  background-color: ${({ $isUser }) => ($isUser ? 'rgba(255,255,255,0.2)' : '#eee')};
  border-radius: 4px;
  margin: 6px 0;
`

interface MessageSkeletonProps {
  style?: React.CSSProperties
}

const MessageSkeleton: React.FC<MessageSkeletonProps> = ({ style }) => {
  return (
    <SkeletonContainer style={style}>
      <BubbleContainer $isUser={true}>
        <BubbleContent $isUser={true}>
          <BubbleBody $isUser={true}>
            <SkeletonLine $width='100%' $isUser={true} />
          </BubbleBody>
        </BubbleContent>
      </BubbleContainer>

      <BubbleContainer $isUser={false}>
        <AvatarContainer>
          <PrixIcon />
        </AvatarContainer>
        <BubbleContent $isUser={false}>
          <BubbleBody $isUser={false} $width='100%'>
            <SkeletonLine $width='90%' />
            <SkeletonLine $width='75%' />
            <SkeletonLine $width='85%' />
          </BubbleBody>
        </BubbleContent>
      </BubbleContainer>

      <BubbleContainer $isUser={true}>
        <BubbleContent $isUser={true}>
          <BubbleBody $isUser={true} $width='50%'>
            <SkeletonLine $width='100%' $isUser={true} />
          </BubbleBody>
        </BubbleContent>
      </BubbleContainer>

      <BubbleContainer $isUser={false}>
        <AvatarContainer>
          <PrixIcon />
        </AvatarContainer>
        <BubbleContent $isUser={false}>
          <BubbleBody $isUser={false} $width='100%'>
            <SkeletonLine $width='100%' />
            <SkeletonLine $width='90%' />
            <SkeletonLine $width='75%' />
            <SkeletonLine $width='85%' />
            <SkeletonLine $width='100%' />
            <SkeletonLine $width='50%' />
          </BubbleBody>
        </BubbleContent>
      </BubbleContainer>
    </SkeletonContainer>
  )
}

export default MessageSkeleton
